import React, { useState, useEffect } from 'react';
import ActivityHeaderLayout from '@monorepo/shared/src/components/activities/ActivityHeaderLayout';
import useBookStore from '@monorepo/shared/src/graph/state/query-hooks/use-book-store';
import { BookType } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import LetterBook from '../../LetterBook';
import StudentBook from '../../StudentBook';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

type Props = {
  bookCode: string;
  bookTitle?: string;
  bookType: BookType;
  letter?: string;
  backRoute?: string;
};

const BookContent: React.FC<Props> = ({ bookCode, bookTitle, bookType, letter, backRoute }) => {
  const omitRoutes = useTrialUserOmitRoutes();
  const [title, setTitle] = useState('');
  const [{ book }] = bookTitle
    ? [{ book: { bookCode, title: bookTitle } }]
    : useBookStore({ bookType, letter });

  useEffect(() => {
    if (book && book.bookCode) {
      setTitle(() => book.title);
    }
  }, [book]);

  return (
    <ActivityHeaderLayout
      title={title}
      hasTogglePageView={true}
      showCloseButton={false}
      backRoute={backRoute}
      omitRoutes={omitRoutes}
    >
      {letter ? <LetterBook letter={letter} /> : <StudentBook />}
    </ActivityHeaderLayout>
  );
};

export default BookContent;
